import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "break-crumb container pt-5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "ant-page-header-heading" }
const _hoisted_5 = { class: "ant-page-header-heading-title" }

import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_breadcrumb, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(route).meta.breadcrumb, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_breadcrumb_item, { key: index }, {
            default: _withCtx(() => [
              (item.key != '')
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createVNode(_component_router_link, {
                      to: item.key
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(item.value)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t(item.value)), 1))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(route).name), 1)
    ])
  ]))
}
}

})